<template>
    <div class="link-list">
        <span class="link-list__title">
            {{ $t('help') | upperCase }}
        </span>
        <ul class="link-list__items">
            <li class="link-list__item">
                <a
                    :href="config.countrySpecific.footer.faqPage"
                    class="static-link"
                    target="_blank"
                >
                    {{ $t('FAQ') }}
                </a>
            </li>
            <li
                @click="onShowLiveChat"
                class="link-list__item"
            >
                {{ $t('Live Chat') }}
            </li>
            <li class="link-list__item">
                <a
                    :href="`mailto:${config.countrySpecific.footer.email}`"
                    class="static-link"
                >
                    <i class="icon--sm icon-email footer__icon"></i>
                    {{ $t('E-mail') }}
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
    import config from '@config';

    export default {
        created() {
            this.config = config;
        },
        methods: {
            onShowLiveChat() {
                this.showHelp();
            }
        },
    };
</script>



// WEBPACK FOOTER //
// src/terminal/poland/app/modules/layout/footer/components/Help.vue